/**
 * Aqui é onde deverá estar todos os serviços referentes a cadastro.
 */
import axios from 'axios';

// Define a URL base da API dinamicamente
const BASE_API =
  window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
    ? 'http://127.0.0.1:8000/api' // URL para ambiente local
    : 'https://mercadinhointeligente.com.br/api'; // URL para ambiente de produção

const BASE_URL =
  window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
    ? 'http://127.0.0.1:8000' // URL para ambiente local
    : 'https://mercadinhointeligente.com.br'; // URL para ambiente de produção

sessionStorage.setItem('BASE_URL', JSON.stringify(BASE_URL)); // Armazenando todos os dados

console.log('Base API:', BASE_API); // Apenas para conferir qual URL está sendo usada

// Configura uma instância do Axios com opções padrão
const api = axios.create({
    baseURL: BASE_API,
    timeout: 10000, // 10 segundos de timeout
    headers: {
        'Content-Type': 'application/json',
    },
});
  
  
// Função para cadastrar um funcionario
export const cadastrarRepresentanteComercial = async (dados) => {

    console.log('Entrou no cadastrarRepresentanteComercial do representanteServico.js...');
    console.log('Dados que serão enviados:', dados);
  
    const endpoint = '/user/cadastrarRepresentanteComercial';
    const fullUrl = `${api.defaults.baseURL}${endpoint}`; // Concatena a baseURL com o endpoint
    
    console.log('URL completa da requisição:', fullUrl);
  
    try {
      const response = await api.post(endpoint, dados);
      return response.data; // Retorna a resposta do backend
    } catch (error) {
      console.error('Erro ao cadastrar:', error.response || error.message);
      throw error; // Lança o erro para ser tratado no componente
    }
  };
  
  export const cancelarTodasViagensEmAndamentoByPiloto = async (dados) => {
    console.log('Entrou no cancelarTodasViagensEmAndamentoByPiloto do cadastroServico.js...');
    console.log('Dados que serão enviados:', dados);
  
    const endpoint = '/viagem/cancelarTodasViagensEmAndamentoByPiloto';
    const fullUrl = `${api.defaults.baseURL}${endpoint}`; // Concatena a baseURL com o endpoint
    
    console.log('URL completa da requisição:', fullUrl);
  
    try {
      const response = await api.post(endpoint, dados);
      return response.data; // Retorna a resposta do backend
    } catch (error) {
      console.error('Erro ao cadastrar:', error.response || error.message);
      throw error; // Lança o erro para ser tratado no componente
    }
  }

  export const atualizarPontoMototaxi = async (formData, id) => {
    console.log('!!! Entrou em atualizarPontoMototaxi em CadastroServico.js.....');

    // const endpoint = `/user/atualizarPontoMototaxi/${id}`;
    const endpoint = `/user/atualizarPontoMototaxi`;
    const fullUrl = `${api.defaults.baseURL}${endpoint}`;
  
    const resposta = await fetch(fullUrl, {
      method: 'POST', // ou PUT, se for assim no backend
      body: formData,
      // headers: {
      //   Authorization: `Bearer ${Cookies.get('token')}`,
      //   // NÃO defina Content-Type manualmente!
      // }
    });
  
    if (!resposta.ok) {
      throw new Error(`Erro ao atualizar: ${resposta.status}`);
    }
  
    return await resposta.json();
  };
  
  export const alterarSenhaUsuario = async (formData) => {
    console.log('!!! Entrou em alterarSenhaPontoMototaxi em CadastroServico.js.....');

    const endpoint = `/user/alterarSenhaUsuario`;
    const fullUrl = `${api.defaults.baseURL}${endpoint}`;
  
    const resposta = await fetch(fullUrl, {
      method: 'POST', // ou PUT, se for assim no backend
      body: formData,
      // headers: {
      //   Authorization: `Bearer ${Cookies.get('token')}`,
      //   // NÃO defina Content-Type manualmente!
      // }
    });
  
    if (!resposta.ok) {
      throw new Error(`Erro ao alterar a senha: ${resposta.status}`);
    }
  
    return await resposta.json();
  };
  

// Função para cadastrar um pnto de mototaxi
export const cadastrarPontoMototaxi = async (formData) => {

    console.log('************');
    console.log('Entrou no cadastrarPontoMototaxi do cadastroServico.js...');
    console.log('Dados que serão enviados:', formData);
  
    const endpoint = '/user/cadastrarPontoMototaxi';
    const fullUrl = `${api.defaults.baseURL}${endpoint}`; // Concatena a baseURL com o endpoint


    const resposta = await fetch(fullUrl, {

        method: 'POST',
        body: formData,
        
        // headers: {
        //   // NÃO defina 'Content-Type', o navegador faz isso automaticamente com multipart/form-data
        //   Authorization: `Bearer ${Cookies.get('token')}`,
        // }
    });

    if (!resposta.ok) {
        throw new Error('Erro ao cadastrar ponto');
    }
    
    return await resposta.json();
    
    
    // console.log('URL completa da requisição:', fullUrl);
  
    // try {
    //   const response = await api.post(endpoint, formData);
    //   return response.data; // Retorna a resposta do backend
    // } catch (error) {
    //   console.error('Erro ao cadastrar:', error.response || error.message);
    //   throw error; // Lança o erro para ser tratado no componente
    // }
  };
  

// Função para cadastrar um pnto de mototaxi
export const cadastrarPilotoMototaxi = async (formData) => {

    console.log('************');
    console.log('Entrou no cadastrarPilotoMototaxi do cadastroServico.js...');
    console.log('Dados que serão enviados:', formData);
  
    const endpoint = '/user/cadastrarPilotoMototaxi';
    const fullUrl = `${api.defaults.baseURL}${endpoint}`; // Concatena a baseURL com o endpoint

    const resposta = await fetch(fullUrl, {
        method: 'POST',
        body: JSON.stringify(formData),
        headers: {
            'Content-Type': 'application/json',
        }
    });

    if (!resposta.ok) {
        throw new Error('Erro ao cadastrar piloto');
    }    
    return await resposta.json();    
  };
  

// Função para cadastrar um pnto de mototaxi
export const cadastrarServicosAtendidos = async (dados) => {

    console.log('************');
    console.log('Entrou no cadastrarServicosAtendidos do cadastroServico.js...');
    console.log('Dados que serão enviados:', dados);
  
    const endpoint = '/ponto/cadastrarServicosAtendidos';
    const fullUrl = `${api.defaults.baseURL}${endpoint}`; // Concatena a baseURL com o endpoint

    const resposta = await fetch(fullUrl, {
        method: 'POST',
        body: JSON.stringify(dados),
        headers: {
            'Content-Type': 'application/json',
        }
    });

    if (!resposta.ok) {
        throw new Error('Erro ao cadastrar piloto');
    }    
    return await resposta.json();    
  };
// Função para cadastrar uma localidade atendida pelo mototáxi
export const cadastrarLocalidadesAtendidas = async (dados) => {

    console.log('************');
    console.log('Entrou no cadastrarLocalidadesAtendidas do cadastroServico.js...');
    console.log('Dados que serão enviados:', dados);
  
    const endpoint = '/ponto/cadastrarLocalidadesAtendidas';
    const fullUrl = `${api.defaults.baseURL}${endpoint}`; // Concatena a baseURL com o endpoint

    const resposta = await fetch(fullUrl, {
        method: 'POST',
        body: JSON.stringify(dados),
        headers: {
            'Content-Type': 'application/json',
        }
    });

    if (!resposta.ok) {
        throw new Error('Erro ao cadastrar piloto');
    }    
    return await resposta.json();    
  };
  
// Função para atualizar o status do piloto - passando dadosCookies - piloto logado
export const atualizarStatusPiloto = async (dados, novoStatus) => {

    console.log('---------------');
    console.log('Entrou em atualizarStatusPiloto do CadastroServico.js....');

    const payload = {
      ...dados,
      novoStatus
    };
  
    console.log('➡️ Atualizando status do piloto...', payload);

    console.log(payload);
    console.log('...praparando para atualizar...');
  
    const endpoint = '/piloto/atualizarStatusPiloto';
    const fullUrl = `${api.defaults.baseURL}${endpoint}`;
  
    const resposta = await fetch(fullUrl, {
      method: 'POST',
      body: JSON.stringify(payload),
      headers: {
        'Content-Type': 'application/json',
        // 'Authorization': `Bearer ${dados.token}` // se precisar de token
      }
    });


    if (!resposta.ok) {
      const erro = await resposta.json().catch(() => null);
      console.log(erro);
      throw new Error(erro?.message || 'Erro ao atualizar o status do piloto');
    }

    console.log('ok, saindo do cadastroServico...')
  
    return await resposta.json();
  };
  
  
// Função para cancelar uma viagem a pedido do cliente
export const cancelarViagemPeloCliente = async (dados) => {

    console.log('---------------');
    console.log('Entrou em cancelarViagemPeloCliente do cadastroServico.js....');

    const payload = {
      ...dados,
    //   novoStatus
    };
  
    console.log('payload: ');
    console.log(payload);
  
    const endpoint = '/viagem/cancelarViagemPeloCliente';
    const fullUrl = `${api.defaults.baseURL}${endpoint}`;
  
    const resposta = await fetch(fullUrl, {
      method: 'POST',
      body: JSON.stringify(payload),
      headers: {
        'Content-Type': 'application/json',
        // 'Authorization': `Bearer ${dados.token}` // se precisar de token
      }
    });
  
    if (!resposta.ok) {
      const erro = await resposta.json().catch(() => null);
      throw new Error(erro?.message || 'Erro ao atualizar o status do piloto');
    }
  
    return await resposta.json();
  };
  
// Função para atualizar o status de uma viagem pelo piloto
export const atualizarStatusViagemPeloPiloto = async (dados, novoStatus) => {

    console.log('---------------');
    console.log('Entrou em atualizarStatusViagemPeloPiloto do cadastroServico.js....');

    const payload = {
      ...dados,
      novoStatus
    };
  
    console.log('payload: ');
    console.log(payload);
  
    const endpoint = '/viagem/atualizarStatusViagemPeloPiloto';
    const fullUrl = `${api.defaults.baseURL}${endpoint}`;
  
    const resposta = await fetch(fullUrl, {
      method: 'POST',
      body: JSON.stringify(payload),
      headers: {
        'Content-Type': 'application/json',
        // 'Authorization': `Bearer ${dados.token}` // se precisar de token
      }
    });

    console.log('Resposta - em cadastroServico: ');
    console.log(resposta.json);
  
    if (!resposta.ok) {
      const erro = await resposta.json().catch(() => null);
      throw new Error(erro?.message || 'Erro ao atualizar o status do piloto');
    }
  
    return await resposta.json();
  };
  
// Função para atualizar o status de uma viagem pelo piloto
export const atualizarStatusViagemPeloCliente = async (dados, novoStatus) => {

    console.log('---------------');
    console.log('Entrou em atualizarStatusViagemPeloCliente do cadastroServico.js....');

    const payload = {
      ...dados,
      novoStatus
    };
  
    console.log('payload: ');
    console.log(payload);
  
    const endpoint = '/viagem/atualizarStatusViagemPeloCliente';
    const fullUrl = `${api.defaults.baseURL}${endpoint}`;
  
    const resposta = await fetch(fullUrl, {
      method: 'POST',
      body: JSON.stringify(payload),
      headers: {
        'Content-Type': 'application/json',
        // 'Authorization': `Bearer ${dados.token}` // se precisar de token
      }
    });

    console.log('Resposta - em cadastroServico: ');
    console.log(resposta.json);
  
    if (!resposta.ok) {
      const erro = await resposta.json().catch(() => null);
      throw new Error(erro?.message || 'Erro ao atualizar o status do piloto');
    }
  
    return await resposta.json();
  };
  

// PELO INTERNAUTA CLIENTE
export const atualizarStatusPilotoByDadosPiloto = async (dados, novoStatus) => {

    console.log('---------------');
    console.log('Entrou em atualizarStatusPiloto do CadastroServico.js....');
    
    const payload = {
      ...dados,
      novoStatus
    };
  
    console.log('➡️ Atualizando status do piloto...', payload);
  
    const endpoint = '/piloto/atualizarStatusPilotoByDadosPiloto';
    const fullUrl = `${api.defaults.baseURL}${endpoint}`;
  
    const resposta = await fetch(fullUrl, {
      method: 'POST',
      body: JSON.stringify(payload),
      headers: {
        'Content-Type': 'application/json',
        // 'Authorization': `Bearer ${dados.token}` // se precisar de token
      }
    });
  
    if (!resposta.ok) {
      const erro = await resposta.json().catch(() => null);
      throw new Error(erro?.message || 'Erro ao atualizar o status do piloto');
    }
  
    return await resposta.json();
  };
  
  

// Função para atualizar o status do piloto - passando só dados do piloto - internauta navegando.
export const solicitarServicoEAtualizarStatusPilotoByDadosPiloto = async (dados, novoStatus, dadosCookies, idPonto) => {

    console.log('---------------');
    console.log('Entrou em solicitarServicoEAtualizarStatusPilotoByDadosPiloto do CadastroServico.js....');
    
    const payload = {
      ...dados,
      novoStatus,
      dadosCookies,
      idPonto
    };
  
    console.log('➡️ Solicitando serviço e atualizando status do piloto...', payload);
  
    const endpoint = '/piloto/solicitarServicoEAtualizarStatusPilotoByDadosPiloto';
    const fullUrl = `${api.defaults.baseURL}${endpoint}`;
  
    const resposta = await fetch(fullUrl, {
      method: 'POST',
      body: JSON.stringify(payload),
      headers: {
        'Content-Type': 'application/json',
        // 'Authorization': `Bearer ${dados.token}` // se precisar de token
      }
    });
  
    if (!resposta.ok) {
      const erro = await resposta.json().catch(() => null);
      throw new Error(erro?.message || 'Erro ao atualizar o status do piloto');
    }
  
    return await resposta.json();
  };
  